<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title_flex">
        <div class="componentSty_content_title">
          <span class="fonints">计划单号</span>
          <el-input
            placeholder="请输入关键词"
            v-model.trim="conditions.pno"
            clearable
          >
          </el-input>
          <span class="fonints">货主</span>
          <el-input
            placeholder="请输入关键词"
            v-model.trim="conditions.customname"
            clearable
          >
          </el-input>
          <span class="fonints">货代</span>
          <el-input
            placeholder="请输入关键词"
            v-model.trim="conditions.agentname"
            clearable
          >
          </el-input>

          <!-- <span class="fonints">计划类型</span>
        <div class="select_box">

          <m-select :list="selectplantype" v-model="planinfo"></m-select>
        </div> -->
          <!-- <m-select
            :list="selectplantype"
            :value="planinfo"
            @input="chanval"
            isObj
          ></m-select> -->
          <!-- <el-input
          placeholder="请输入关键词"
          v-model.trim="conditions.customername"
          clearable -->
          <!-- > -->
          <!-- </el-input> -->
        </div>
        <div class="componentSty_content_title_flex_button">
          <button class="buttons" @click="selectlist">查询</button>
          <!-- <button class="buttons" style="background: #13d168" @click="switchOnOff(true)">
            启用
          </button>
          <button class="buttons" style="background: #F5F6FA;color: #17B6A1;" @click="switchOnOff(false)">
            暂停
          </button> -->
        </div>
      </div>
      <div class="componentSty_content_title">
        <span class="fonints">计划来源</span>
        <!-- <el-input
          placeholder="请输入关键词"
          v-model="conditions.stname"
          clearable
        >
        </el-input> -->
        <div
          class="select_box"
          style="background-color: #fff; line-height: 30px"
        >
          <el-select
            v-model="selectinfo"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="it in changdisel"
              :key="it.value"
              :value="it.value"
              :label="it.label"
            ></el-option>
          </el-select>

          <!-- <m-select :list="selectastrict" v-model="selectinfo"></m-select> -->
        </div>
        <span class="fonints">生产系统状态</span>
        <div class="select_box">
          <m-select
            :list="selectastrict2"
            :value="selectVal"
            @input="chanval"
            isObj
          ></m-select>
        </div>
        <el-radio-group style="margin: 0 10px" v-model="conditions.plantype">
          <el-radio :label="null">全部</el-radio>
          <el-radio :label="3">港内集疏计划</el-radio>
          <el-radio :label="4">火运下线</el-radio>
          <el-radio :label="1">备货计划</el-radio>
          <el-radio :label="2">提货计划</el-radio>
        </el-radio-group>
      </div>
      <div class="componentSty_content_title">
        <span class="fonints">日期</span>
        <el-date-picker
          v-model="conditions.startTime"
          type="date"
          class="inp"
          value-format="yyyy-MM-dd"
          placeholder="开始时间"
        >
        </el-date-picker>
        <span class="fonints" style="margin-left: 0">至</span>
        <el-date-picker
          v-model="conditions.endTime"
          type="date"
          class="inp"
          value-format="yyyy-MM-dd"
          placeholder="结束时间"
        >
        </el-date-picker>
        <span class="fonints">船名</span>
        <el-input
          placeholder="请输入关键词"
          v-model.trim="conditions.shipname"
          clearable
        >
        </el-input>
      </div>
      <div
        class="componentSty_content_table"
        style="top: 140px; border: none"
        v-if="$route.query.obj"
      >
        <el-table
          border
          :data="arrlist.list"
          style="width: 100%; height: 80%"
          @sort-change="sortchange"
          height="80%"
        >
          <el-table-column
            show-overflow-tooltip
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            :render-header="renderHeader"
            prop="pno"
            sortable="custom"
            label="计划单号"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="plantype"
            :render-header="renderHeader"
            label="计划类型"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="customname"
            :render-header="renderHeader"
            label="货主"
          >
            <!-- <template slot-scope="scope">
              <div>
                {{ scope.row.customname==="null"?"" : scope.row.customname }}
              </div>
            </template> -->
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="agentname"
            :render-header="renderHeader"
            label="货代"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="shipname"
            :render-header="renderHeader"
            label="船名"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="stname"
            :render-header="renderHeader"
            label="计划来源"
          >
            <template slot-scope="scope">
              <div>
                {{ changdi[scope.row.stname] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="goodsname"
            :render-header="renderHeader"
            label="货物名称"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="source"
            :render-header="renderHeader"
            label="发货地"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="destination"
            :render-header="renderHeader"
            label="发往地"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="计划吨数"
            :render-header="renderHeader"
          >
            <template v-slot="res">
              <span>{{ res.row.plantons }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="完成吨数"
            :render-header="renderHeader"
          >
            <template v-slot="res">
              <span>{{ res.row.workedSullte }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column show-overflow-tooltip label="本地状态" :render-header="renderHeader">
            <template v-slot="res">
              <span v-if="res.row.localhoststatus == 0" style="color: rgb(19, 209, 105); cursor: pointer">进行中</span>
              <span v-if="res.row.localhoststatus == 1" style="color: #17B6A1">完成</span>
              <span v-if="res.row.localhoststatus == 2" style="color: #fcad50; cursor: pointer">暂停</span>
              <span v-if="res.row.localhoststatus == 3" style="color: rgb(254, 90, 36)">作废</span>
            </template>
          </el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="生产系统状态"
            :render-header="renderHeader"
          >
            <template v-slot="res">
              <span
                v-if="res.row.status == 0"
                style="color: rgb(19, 209, 105); cursor: pointer"
                >进行中</span
              >
              <span v-if="res.row.status == 1" style="color: #17b6a1"
                >完成</span
              >
              <span
                v-if="res.row.status == 2"
                style="color: #fcad50; cursor: pointer"
                >暂停</span
              >
              <span v-if="res.row.status == 3" style="color: rgb(254, 90, 36)"
                >作废</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="res">
              <span
                class="iconfont icon-xiugai"
                @click="jumpParticulars(res.row)"
              ></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :total="arrlist.total"
            :current-page="conditions.page"
            @current-change="getListByQuery"
          >
          </el-pagination>
        </div>
      </div>
      <div
        class="componentSty_content_table"
        style="top: 140px; border: none"
        v-else
      >
        <el-table
          border
          :data="arrlist.data"
          style="width: 100%; height: 80%"
          @sort-change="sortchange"
          height="80%"
        >
          <el-table-column
            show-overflow-tooltip
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            :render-header="renderHeader"
            prop="pno"
            sortable="custom"
            label="计划单号"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="plantype"
            :render-header="renderHeader"
            label="计划类型"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="customname"
            :render-header="renderHeader"
            label="货主"
          >
            <!-- <template slot-scope="scope">
              <div>
                {{ scope.row.customname==="null"?"" : scope.row.customname }}
              </div>
            </template> -->
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="agentname"
            :render-header="renderHeader"
            label="货代"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="shipname"
            :render-header="renderHeader"
            label="船名"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="stname"
            :render-header="renderHeader"
            label="计划来源"
          >
            <template slot-scope="scope">
              <div>
                {{ changdi[scope.row.stname] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="goodsname"
            :render-header="renderHeader"
            label="货物名称"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="source"
            :render-header="renderHeader"
            label="发货地"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="destination"
            :render-header="renderHeader"
            label="发往地"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="计划吨数"
            :render-header="renderHeader"
          >
            <template v-slot="res">
              <span>{{ res.row.plantons }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="完成吨数"
            :render-header="renderHeader"
          >
            <template v-slot="res">
              <span>{{ res.row.sumSullte }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column show-overflow-tooltip label="本地状态" :render-header="renderHeader">
            <template v-slot="res">
              <span v-if="res.row.localhoststatus == 0" style="color: rgb(19, 209, 105); cursor: pointer">进行中</span>
              <span v-if="res.row.localhoststatus == 1" style="color: #17B6A1">完成</span>
              <span v-if="res.row.localhoststatus == 2" style="color: #fcad50; cursor: pointer">暂停</span>
              <span v-if="res.row.localhoststatus == 3" style="color: rgb(254, 90, 36)">作废</span>
            </template>
          </el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="生产系统状态"
            :render-header="renderHeader"
          >
            <template v-slot="res">
              <span
                v-if="res.row.status == 0"
                style="color: rgb(19, 209, 105); cursor: pointer"
                >进行中</span
              >
              <span v-if="res.row.status == 1" style="color: #17b6a1"
                >完成</span
              >
              <span
                v-if="res.row.status == 2"
                style="color: #fcad50; cursor: pointer"
                >暂停</span
              >
              <span v-if="res.row.status == 3" style="color: rgb(254, 90, 36)"
                >作废</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="res">
              <span
                class="iconfont icon-xiugai"
                @click="jumpParticulars(res.row)"
              ></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="msgstatistics">
          <span style="margin-right: 20px">计划合计:{{ arrlist.Count }}条</span>
          <!-- <span>合计净重:{{ suttlesum / 1000  }} 吨</span> -->
        </div>
        <div class="paginations" v-show="arrlist.data && arrlist.data.length">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :total="arrlist.Count"
            :current-page="conditions.page"
            @current-change="getarrlist"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
// import { mapMutations, mapState } from "vuex";
import mSelect from "@/components/mSelect";
import changdi from "@/plugins/changdi.json";
export default {
  data() {
    return {
      listitem: [{ name: "计划管理" }, { name: "计划列表" }],
      changdi: changdi,
      conditions: {
        page: 1,
        limit: 20,
        plantype: null,
        pno: null,
        customname: null,
        shipname: null,
        customername: null,
        agentname: null,
        status: null,
        startTime: null,
        endTime: null,
      },
      // selectastrict: [],
      changdisel: [
        { label: "前沿货场", value: "jiaotan" },
        { label: "港俊货场", value: "gangjun" },
        { label: "昊德", value: "haode" },
        { label: "琦晟", value: "qisheng" },
        { label: "睿鑫", value: "ruixin" },
        { label: "通达", value: "tongda" },
        { label: "富泉", value: "fuquan" },
      ],
      selectastrict2: [
        {
          status: null,
          val: "全部",
        },
        {
          status: 0,
          val: "进行中",
        },
        {
          status: 1,
          val: "完成",
        },
        {
          status: 2,
          val: "暂停",
        },
        {
          status: 3,
          val: "作废",
        },
      ],
      selectplantype: ["全部", "备货", "提货", "港内集疏"],
      arrlist: {},
      selectVal: "全部",
      selectinfo: "jiaotan",
      planinfo: "全部",
      plantype: "",
    };
  },
  // computed: {
  //   ...mapState(["conditionsList"]),
  // },
  components: {
    mTitle,
    mSelect,
  },
  created() {
    // this.conditionsList[this.$route.path] ||
    //   this.createConditions({ key: this.$route.path });
    // this.conditions = this.conditionsList[this.$route.path] || {
    //   page: 1,
    //   limit: 20,
    // };
    console.log(this.$route.query.obj);
    if (this.$route.query.obj) {
      this.conditions.plantype = JSON.parse(this.$route.query.obj).plantype;
      this.conditions.pno = JSON.parse(this.$route.query.obj).pno;
      this.conditions.status = JSON.parse(this.$route.query.obj).status;
      this.conditions.startTime = JSON.parse(this.$route.query.obj).startTime;
      this.conditions.endTime = JSON.parse(this.$route.query.obj).endTime;
      this.conditions.shipname = JSON.parse(this.$route.query.obj).shipname;
      this.conditions.stname = JSON.parse(this.$route.query.obj).stname;
      this.selectVal = JSON.parse(this.$route.query.obj).selectVal;
      this.selectinfo = JSON.parse(this.$route.query.obj).stname;
      this.getListByQuery();
    } else {
      this.getarrlist();
    }
  },
  methods: {
    // ...mapMutations(["createConditions"]),
    async getListByQuery(num) {
      typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/fleet/plan/planListPcWorkReport",
        "post",
        this.conditions
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.arrlist = data.data;
      this.arrlist.list.map((item) => {
        item.plantype =
          item.plantype == 1
            ? "备货"
            : item.plantype == 2
            ? "提货"
            : "港内集疏";
      });
    },
    // 获取列表数据
    async getarrlist(num) {
      typeof num === "number" && (this.conditions.page = num);
      this.selectinfo == "全部"
        ? (this.conditions.stname = null)
        : (this.conditions.stname = this.selectinfo);
      const { data } = await this.$http(
        "api1",
        "/fleet/plan/planListPcByPaymentChannel",
        "post",
        this.conditions
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.arrlist = data;
      this.arrlist.data.map((item) => {
        item.plantype =
          item.plantype == 1
            ? "备货"
            : item.plantype == 2
            ? "提货"
            : "港内集疏";
      });
    },
    // 获取货场列表
    async getselectastrict() {
      const { data } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "货场",
      });
      if (data.code != 0) return;
      this.selectastrict = ["全部"];
      data.data.forEach((item) => {
        this.selectastrict.push(item.val);
      });
    },
    switchOnOff(bool) {
      antiShake((_) => {
        let path = "",
          title = bool ? "启用" : "暂停";
        if (this.conditions.paymentChannel) {
          path = bool
            ? this.conditions.paymentChannel == 1
              ? "/fleet/plan/planOneKeyToStartByOnlinePayment"
              : "/fleet/plan/planOneKeyToStartByOfflinePayment"
            : this.conditions.paymentChannel == 1
            ? "/fleet/plan/planOneKeyToSuspendByOnlinePayment"
            : "/fleet/plan/planOneKeyToSuspendByOfflinePayment";
        } else {
          path = bool
            ? "/fleet/plan/planOneKeyToStart"
            : "/fleet/plan/planOneKeyToSuspend";
        }
        this.$messageBox
          .confirm(`是否${title}`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(async () => {
            const { data } = await this.$http(
              "api1",
              path,
              "post",
              this.conditions
            );
            if (data.code != 0) return this.$message.error(data.msg);
            this.$message.success(`${title}成功`);
            if (this.$route.query.obj) {
              this.getListByQuery();
            } else {
              this.getarrlist(1);
            }
          })
          .catch((err) => err);
      });
    },
    selectlist() {
      this.plantype =
        this.planinfo == "备货"
          ? 1
          : this.planinfo == "提货"
          ? 2
          : this.planinfo == "港内集疏"
          ? 3
          : "";
      antiShake((_) => {
        this.conditions.page = 1;
        if (this.$route.query.obj) {
          this.getListByQuery();
        } else {
          this.getarrlist();
        }
      });
    },
    sortchange(event) {
      if (event.order == "ascending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "asc";
      } else if (event.order == "descending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "desc";
      } else {
        this.conditions.sidx = "";
        this.conditions.order = "";
      }
      if (this.$route.query.obj) {
        this.getListByQuery();
      } else {
        this.getarrlist();
      }
    },
    jumpParticulars(res) {
      antiShake((_) => {
        window.sessionStorage.setItem(
          "infoid",
          JSON.stringify({ id: res.id, pno: res.pno, sumSullte: res.sumSullte })
        );
        this.$router.push({
          name: "planlistParticulars",
          query: { plantype: res.plantype },
        });
      });
    },
    chanval(data) {
      this.conditions.status = data.status;
      this.selectVal = data.val;
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
